import APIService from '../services/api.service';

let user = null
if (localStorage.getItem('user') != 'undefined') {
  user = JSON.parse(localStorage.getItem('user'));
}

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, data) {
      return APIService.auth_Login(data.email, data.password, data.app, data.rememberMe).then(
        data => {
          commit('loginSuccess');
          return Promise.resolve(data);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      commit('logout');
      APIService.logout();
      // User-scoped States zuruecksetzen: der main-Store ueberlebt den Logout,
      // sonst bedient der initializeUserData-Guard nach Login als B die Daten von A.
      // { root: true }, weil auth namespaced ist und 'set' im main-Modul (root) liegt.
      commit('set', { state: 'user', data: {} }, { root: true });
      commit('set', { state: 'webshop_user', data: {} }, { root: true });
      commit('set', { state: 'auth_user', data: {} }, { root: true });
      commit('set', { state: 'cart', data: { result: [] } }, { root: true });
    },
  },
  mutations: {
    loginSuccess(state) {
      state.status.loggedIn = true;
      if (localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined') {
        state.user = JSON.parse(localStorage.getItem('user'));
      }
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    setUser(state, user) {
      state.user = user;
    }
  }
};
